import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import * as utilsUnderwriter from "../utils/underwriter";

const initialState = {
    companies: [],
    loading: false,
    saving: false
};

export default function company(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_COMPANY:
            newState.loading = true;
            break;

        case actions.SAVING_COMPANY:
            newState.saving = true;
            break;

        case actions.RECEIVED_COMPANIES:
            newState.companies = utils.mapById(utilsUnderwriter.flattenCountry(action.payload));
            newState.loading = false;
            break;

        case actions.SAVED_COMPANY:
            let found = false;

            for (let i = 0; i < newState.companies.length; i++) {
                if(newState.companies[i].id === action.payload.id){
                    found = true;

                    newState.companies[i] = action.payload;
                }
            }

            if(!found) {
                newState.companies.add(
                    action.payload
                );
            }
            newState.companies = utils.mapById(utilsUnderwriter.flattenCountry(newState.companies));
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_COMPANIES:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/company.js